
/** @param {{ itemSingular: string, query?: string | null, hasExtraFilter?: boolean, extraFilterLabel?: string }} opts */
export function getCatalogEmptyCopy({
	itemSingular,
	query,
	hasExtraFilter,
	extraFilterLabel,
}) {
	const trimmedQuery = (query ?? "").trim();

	if (trimmedQuery) {
		return {
			message: `${itemSingular} با این نام پیدا نشد.`,
			hint: "کلمهٔ دیگری جستجو کنید یا فیلترها را پاک کنید.",
			showClear: true,
		};
	}

	if (hasExtraFilter && extraFilterLabel) {
		return {
			message: `${itemSingular} در ${extraFilterLabel} یافت نشد.`,
			hint: "تخصص دیگری انتخاب کنید یا فیلتر را پاک کنید.",
			showClear: true,
		};
	}

	if (hasExtraFilter) {
		return {
			message: `${itemSingular} با این فیلتر یافت نشد.`,
			hint: "فیلتر را تغییر دهید یا همهٔ موارد را ببینید.",
			showClear: true,
		};
	}

	return {
		message: `هنوز ${itemSingular}ی منتشر نشده است.`,
		hint: "به‌زودی محتوای جدید اضافه می‌شود.",
		showClear: false,
	};
}
